var swiper = new Swiper(".swiper-image-card-v1", {
    slidesPerView: "auto",
    spaceBetween: 24,
    grabCursor: true,
    navigation: {
        nextEl: "#carousel-v1-next",
        prevEl: "#carousel-v1-prev",
     },
    pagination: {
        clickable: true,
        el: "#carousel-v1-pagination",
     },
  });
